export const DECISION_STEPS = {
  MERCHANT_TRANSFER_TYPE_CHECK: 'MerchantTransferTypeCheck',
  AUTO_TRADE_CREDIT_NOTIFICATION: 'AutoTradeCreditNotification',
  PENDING_MERCHANT_TRANSFER: 'PendingMerchantTransfer',
} as const
